import "./RecommendedItem.css";

export default function RecommendedItem({ item, onClick }) {
    return (
        <div
            className="recommended-item"
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") onClick?.(e);
            }}
        >
            <div className="recommended-item-image-container">
                <img
                    loading="lazy"
                    decoding="async"
                    src={item.imageUrl}
                    alt={item.alt || item.name || "Produkt"}
                    draggable="false"
                    width="180"
                    height="180"
                    style={{ objectFit: "cover" }}
                />
            </div>
            <div className="recommended-item-name">{item.name}</div>
            <div className="recommended-item-price-container">
                {item?.price?.discountedPrice != null && (
                    <span className="recommended-item-discount-price">
            {Number(item.price.discountedPrice).toFixed(2)} zł
          </span>
                )}
                <span className="recommended-item-price">
          {Number(item?.price?.price ?? 0).toFixed(2)} zł
        </span>
            </div>
        </div>
    );
}
